const COMPRESSIBLE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp'
]

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    const objectUrl = URL.createObjectURL(file)

    image.onload = () => {
      URL.revokeObjectURL(objectUrl)
      resolve(image)
    }

    image.onerror = (error) => {
      URL.revokeObjectURL(objectUrl)
      reject(error)
    }

    image.src = objectUrl
  })
}

function canvasToBlob(canvas, type, quality) {
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          reject(new Error('Could not create compressed image blob'))
          return
        }
        resolve(blob)
      },
      type,
      quality
    )
  })
}

export function calculateDimensions(width, height, maxWidthOrHeight) {
  if (width <= maxWidthOrHeight && height <= maxWidthOrHeight) {
    return { width, height }
  }

  if (width >= height) {
    return {
      width: maxWidthOrHeight,
      height: Math.round((height * maxWidthOrHeight) / width)
    }
  }

  return {
    width: Math.round((width * maxWidthOrHeight) / height),
    height: maxWidthOrHeight
  }
}

export async function compressImageForUpload(file, options = {}) {
  if (!file) return file

  const {
    maxWidthOrHeight = 1600,
    quality = 0.75,
    minBytesToCompress = 250 * 1024
  } = options

  if (!COMPRESSIBLE_TYPES.includes(file.type)) return file
  if (file.size < minBytesToCompress) return file

  const image = await loadImage(file)
  const dimensions = calculateDimensions(
    image.naturalWidth,
    image.naturalHeight,
    maxWidthOrHeight
  )

  const canvas = document.createElement('canvas')
  canvas.width = dimensions.width
  canvas.height = dimensions.height

  const context = canvas.getContext('2d')
  if (!context) return file

  context.drawImage(image, 0, 0, dimensions.width, dimensions.height)
  const blob = await canvasToBlob(canvas, file.type, quality)

  if (blob.size >= file.size * 0.98) return file

  return new File([blob], file.name, {
    type: blob.type || file.type,
    lastModified: Date.now()
  })
}
